import FpuiPackages from './FpuiPackages.vue'

export default FpuiPackages
